import { memo } from 'react';
import { ActionIcon } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import type { FilterPillProps } from './FilterPill.types';
import styles from './FilterPill.module.css';

export const FilterPill = memo(function FilterPill({
  label,
  value,
  onRemove,
  ariaLabel,
}: FilterPillProps) {
  return (
    <div className={styles.pill}>
      <span className={styles.label}>{label}:</span>
      <span className={styles.value}>{value}</span>
      <ActionIcon
        variant="subtle"
        color="gray"
        size="xs"
        onClick={onRemove}
        aria-label={ariaLabel}
        className={styles.removeButton}
      >
        <IconX size={14} />
      </ActionIcon>
    </div>
  );
});
